/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { LoggingService } from '../../logging/logic/logging.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';
import { TourService } from '../../tour/logic/tour.service';
import { TourGPSStatus } from 'src/app/_model/tour';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';

/**
 * Visibility Service checks for given Rules if something is visible
 */
@Injectable({
  providedIn: 'root',
})
export class NeedsAppGPSVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'needsAppGPS';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private tourService: TourService,
    private appParameterService: AppParameterService
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    const tourId = this.clientStateService.theState.getValue().tourId;
    if (tourId == undefined) {
      return false;
    }

    const tour = this.tourService.getTourById(tourId);
    if (tour == undefined) {
      return false;
    }

    if (
      tour.isQuickTour &&
      !this.appParameterService.appParameters$
        .getValue()
        .getBooleanParameter('imsmc.tourmode.quicktour.needs-gps', false)
    ) {
      return false;
    }

    if (tour.hasActiveManagedDevice) {
      return false;
    }

    if (tour.gpsStatus != TourGPSStatus.STATUS_NOT_STARTED) {
      return false;
    }

    if (
      !this.appParameterService.appParameters$
        .getValue()
        .getBooleanParameter('imsmc.tour.btrip-generation', false)
    ) {
      return false;
    }

    return true;
  }

  // Private Functions
}
